import React from "react";
import { TopTrendingStationsTemplate } from "themes/administration/analytics/components";

function TopTrendingStations(props) {
    return <TopTrendingStationsTemplate {...props} />;
}

export default TopTrendingStations;
